export const SIDEBAR_WIDTH = 420;
export const SIDEBAR_BOX_SHADOW_BLUR = 20;

export const ADD_ACTIONS_PANEL_WIDTH = 270;
export const ADD_ACTIONS_PANEL_OFFSET = 15;

export const CANVAS_BG_SIZE = 40;

// 1000 corresponds to 100%. We use 1000 instead of 100 because we want to allow
// for 1 point decimal precision (100.0), but the backend only supports integers
// for cohort values. The UI will divide these cohorts by 10.
export const MAX_RANDOM_COHORT_ALLOCATION = 1000;
export const RANDOM_COHORT_ALLOCATION_DIVISOR = 10;

export const KEYBOARD_SHORTCUT_LOCAL_STORAGE_KEY = 'has-used-vwb-zoom-shortcuts';

export const IN_VIEWPORT_CAMPAIGN_SIZE_THRESHOLD = 100;
